import { render, staticRenderFns } from "./NewsItemSourceDateCategory.vue?vue&type=template&id=40d67494&scoped=true&"
import script from "./NewsItemSourceDateCategory.vue?vue&type=script&lang=js&"
export * from "./NewsItemSourceDateCategory.vue?vue&type=script&lang=js&"
import style0 from "./NewsItemSourceDateCategory.vue?vue&type=style&index=0&id=40d67494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d67494",
  null
  
)

export default component.exports